var _title, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSilent = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon/latency/silent")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/latency/silent",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3606789,23.9407895 L11.3606789,20.8177343 L4.29985856,20.8177343 L11.3154173,10.882798 L11.3154173,7.94078947 L0.090523338,7.94078947 L0.090523338,11.0412138 L6.9476662,11.0412138 L0,20.998781 L0,23.9407895 L11.3606789,23.9407895 Z M24.0698925,11.9407895 L24.0698925,8.86552066 L18.5215054,8.86552066 L23.8548387,2.84401528 L23.8548387,-0.0592105263 L14.5860215,-0.0592105263 L14.5860215,2.99455291 L19.6612903,2.99455291 L14.5,9.03756367 L14.5,11.9407895 L24.0698925,11.9407895 Z",
    id: "Zz",
    fill: "#00838F",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSilent, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/silent.dce2042b.svg";
export { ForwardRef as ReactComponent };